import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";

import AnalyticsDashboard from './pages/analytics-dashboard';
import Registration from './pages/registration';
import Login from './pages/login';
import LandingPage from './pages/landing-page';
import AboutUs from './pages/about-us';
import PrivacyPolicy from './pages/privacy-policy';
import ContactUs from './pages/contact-us';
import TermsOfUse from './pages/terms-of-use';
import Features from "pages/features";
import Pricing from "pages/pricing";
import ForStudents from "pages/for-students";
import HelpCenter from "pages/help-center";
import MoreShakespeare from "pages/more-shakespeare";
import CookiePolicy from "pages/cookie-policy";
import PronunciationAnalyticsDashboard from './pages/pronunciation-analytics-dashboard';

import PlayReadingInterface from './pages/play-reading-interface';

import QuizInterface from './pages/quiz-interface';
import StudentStageDashboard from './pages/student-stage-dashboard';
import StudentPlaysLibrary from './pages/student-plays-library';
import StudentGlossaryExplorer from './pages/student-glossary-explorer';
import StudentProgressCenter from './pages/student-progress-center';
import AdminDashboard from './pages/admin-dashboard';
import UserManagement from './pages/user-management';
import PlayManagement from './pages/play-management';
import EditPlay from './pages/edit-play';
import CharacterManagement from './pages/character-management';
import GlossaryManagement from './pages/glossary-management';
import SiteSettings from './pages/site-settings';
import AudioFileManagement from "pages/audio-file-management";
import AudioProductionDashboard from './pages/audio-production-dashboard';
import VoiceActorAssignmentInterface from './pages/voice-actor-assignment-interface';
import StudentGoalSettingCenter from 'pages/student-goal-setting-center';
import AIQuizGenerator from './pages/ai-quiz-generator';
import LineEditingModal from './pages/line-editing-modal';
import AudioQualityValidationDashboard from './pages/audio-quality-validation-dashboard';
import VoiceActorPerformanceAnalytics from './pages/voice-actor-performance-analytics';
import VoiceActorPortalDashboard from './pages/voice-actor-portal-dashboard';
import PerformerProfile from './pages/performer-profile';
import TrendingPerformersFeed from './pages/trending-performers-feed';
import CharactersLibrary from './pages/characters-library';
import CharacterDetailPage from './pages/character-detail-page';
import CharacterNetworkVisualization from './pages/character-network-visualization';
import AdminAvatarAssetStudio from './pages/admin-avatar-asset-studio';
import StudentAvatarStudio from './pages/student-avatar-studio';
import BadgeManagement from './pages/badge-management';
import AchievementManagement from './pages/achievement-management';
import BadgeAchievementAnalytics from './pages/badge-achievement-analytics';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/features" element={<Features />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/for-students" element={<ForStudents />} />
          <Route path="/help-center" element={<HelpCenter />} />
          <Route path="/more-shakespeare" element={<MoreShakespeare />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/registration" element={<Registration />} />
          <Route path="/login" element={<Login />} />
          <Route path="/performer-profile/:performerId" element={<PerformerProfile />} />
          <Route path="/trending-performers-feed" element={<TrendingPerformersFeed />} />
          <Route path="/characters-library" element={<CharactersLibrary />} />
          <Route path="/character-detail-page" element={<CharacterDetailPage />} />
          <Route path="/character-network-visualization" element={<CharacterNetworkVisualization />} />
          
          {/* Student Routes */}
          <Route path="/student-stage-dashboard" element={<StudentStageDashboard />} />
          <Route path="/student-plays-library" element={<StudentPlaysLibrary />} />
          <Route path="/student-glossary-explorer" element={<StudentGlossaryExplorer />} />
          <Route path="/student-progress-center" element={<StudentProgressCenter />} />
          <Route path="/play-reading-interface" element={<PlayReadingInterface />} />
          <Route path="/quiz-interface" element={<QuizInterface />} />
          <Route path="/quiz/:quizId" element={<QuizInterface />} />
          <Route path="/voice-actor-assignment-interface" element={<VoiceActorAssignmentInterface />} />
          <Route path="/voice-actor-portal-dashboard" element={<VoiceActorPortalDashboard />} />
          <Route path="/student-avatar-studio" element={<StudentAvatarStudio />} />
          
          {/* Admin Routes */}
          <Route path="/admin-dashboard" element={<AdminDashboard />} />
          <Route path="/user-management" element={<UserManagement />} />
          <Route path="/student-goal-setting-center" element={<StudentGoalSettingCenter />} />
          <Route path="/play-management" element={<PlayManagement />} />
          <Route path="/edit-play" element={<EditPlay />} />
          <Route path="/line-editing-modal" element={<LineEditingModal />} />
          <Route path="/character-management" element={<CharacterManagement />} />
          <Route path="/glossary-management" element={<GlossaryManagement />} />
          <Route path="/pronunciation-analytics-dashboard" element={<PronunciationAnalyticsDashboard />} />
          <Route path="/analytics-dashboard" element={<AnalyticsDashboard />} />
          <Route path="/audio-production-dashboard" element={<AudioProductionDashboard />} />
          <Route path="/audio-quality-validation-dashboard" element={<AudioQualityValidationDashboard />} />
          <Route path="/voice-actor-performance-analytics" element={<VoiceActorPerformanceAnalytics />} />
          <Route path="/site-settings" element={<SiteSettings />} />
          <Route path="/audio-file-management" element={<AudioFileManagement />} />
          <Route path="/admin/ai-quiz-generator" element={<AIQuizGenerator />} />
          <Route path="/admin-avatar-asset-studio" element={<AdminAvatarAssetStudio />} />
          <Route path="/badge-management" element={<BadgeManagement />} />
          <Route path="/achievement-management" element={<AchievementManagement />} />
          <Route path="/badge-achievement-analytics" element={<BadgeAchievementAnalytics />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;